import { render, staticRenderFns } from "./my-vehicle-infos.vue?vue&type=template&id=1448f8a0&scoped=true"
import script from "./my-vehicle-infos.vue?vue&type=script&lang=js"
export * from "./my-vehicle-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448f8a0",
  null
  
)

export default component.exports